import { all, takeLatest, put, takeEvery, select } from 'redux-saga/effects';
import { GET_UNIT_LI, GET_UNIT_LI_COUNT, GET_UNIT_LI_PAGE, GET_UNIT, GET_UNIT_SLUG_CONDITION  } from '../constants';
import { getUnitLi, getUnitLiCount, apiError, getUnitLiPage, getUnitLiPageData, getUnit, getUnitSlugCondition, getUnitData } from '../actions';
import axios from 'axios';
import dlCommon from '../dlCommon';
import { dlUnitSkipValGet, dlUnitCondGet, dlUnitMaxPerPageGet } from '../selectors';
import DlUnit from '../models/DlUnit';


export function* sgGetUnitLi(action) {
    const condS = JSON.stringify(action.payload.dlUnitCond);
    const url = dlCommon.apiUrlGet('dl-custom') + '?itemType=dl_unit&cond=' + condS + '&customType=count';
    const itemCount = yield axios.get(url).then((res) => {
        // console.log('saga res');
        // console.log(res);
        const val = parseInt(res.data);
        return val;

    });

    // console.log('itemCount');
    // console.log(itemCount);
    
    yield put(getUnitLiCount(itemCount));

}

export function* sgGetUnitLiCount(action) {
    yield put(getUnitLiPage(1));
}

function* sgGetUnitLiPage(action) {
    const cond = yield select(dlUnitCondGet);
    const condS = JSON.stringify(cond);
    const sort = {['fVals.210_d']: 1};
    const sortS = JSON.stringify(sort);
    const skipVal = yield select(dlUnitSkipValGet);    
    const dlUnitMaxPerPage = yield select(dlUnitMaxPerPageGet);
    const url = dlCommon.apiUrlGet('dl-custom') + '?itemType=dl_unit&cond=' + condS + '&sort=' + sortS + '&skip=' + skipVal + '&limit=' + dlUnitMaxPerPage;       
    const items = yield axios.get(url).then((res) => res.data);
    // console.log('items');
    // console.log(items);
    
    yield put(getUnitLiPageData(items));

}

function* sgGetUnit(action) {
    const itemId = action.payload;
    const url = dlCommon.apiUrlGet('dl-unit', itemId);
    // console.log('itemId', itemId, url);
    const item = yield axios.get(url).then((res) => {
        let item = new DlUnit();
        item.obSet(res.data);
        return item;
    } );
    yield put(getUnitData(item));
}

function* sgGetUnitSlugCondition(action) {
    const itemId = action.payload;
    // const url = dlCommon.apiUrlGet('dl-unit', itemId);
    const url = dlCommon.apiUrlGet('dl-unit', `?mgsFind={"slug":"${itemId}"}`);
    // console.log('itemId', itemId, url);
    // console.log('url', url);
    const item = yield axios.get(url).then((res) => {
        let item = new DlUnit();
        item.obSet(res.data[0]);
        return item;
    } );
    yield put(getUnitData(item));
}

export function* actWatchDlUnit() {
    yield takeLatest(GET_UNIT_LI, sgGetUnitLi);   
    yield takeLatest(GET_UNIT_LI_COUNT, sgGetUnitLiCount);   
    yield takeLatest(GET_UNIT_LI_PAGE, sgGetUnitLiPage);  
    yield takeLatest(GET_UNIT, sgGetUnit); 
    yield takeLatest(GET_UNIT_SLUG_CONDITION, sgGetUnitSlugCondition); 
    // yield takeEvery(ADD_UNIT, sgAddItem);
    // yield takeEvery(DELETE_UNIT, sgDeleteItem);
}

